import { HTTPHeaders } from '@/globals/enums';
import { STORAGE_KEYS } from '@/constants/storage';
import StorageService from './StorageService';
import { dialogService } from './dialog.service';
import arobaOpenAxios from '../services/axios/aroba-oapi-axios.service';

/**
 * Retrieves the Aroba view token from local storage.
 *
 * @returns {Object} - The Aroba view token object stored in local storage.
 */
export function getArobaViewToken() {
  const token = StorageService.getItem(STORAGE_KEYS.SCMCognitoToken);

  return token;
}

/**
 * Checks if the Aroba token is expired.
 *
 * @returns {boolean} - Returns true if the token is expired, otherwise false.
 */
export function isArobaTokenExpired() {
  const token = getArobaViewToken();
  const expirationTime = token.expiresDate * 1000;
  const currentTime = Date.now();
  return expirationTime < currentTime;
}

/**
 * Refreshes the Aroba token by making a request to the refresh endpoint.
 *
 * @returns {Promise<Object>} - A promise that resolves to the new token data if the refresh is successful.
 */
export async function refreshArobaToken() {
  try {
    const congnitoSCMToken = StorageService.getItem(
      STORAGE_KEYS.SCMCognitoToken
    );
    const resSCMRefresh = await arobaOpenAxios.post(
      process.env.VUE_APP_API_BASE_URL + '/ccs/v1/user/refresh',
      {
        refreshToken: congnitoSCMToken.refreshToken,
      },
      {
        headers: {
          [HTTPHeaders.Authorization]: StorageService.getItem(
            STORAGE_KEYS.basicAuth
          ),
        },
      }
    );
    StorageService.setItem(STORAGE_KEYS.SCMCognitoToken, resSCMRefresh.data);

    return resSCMRefresh.data;
  } catch (err) {
    console.log(err);

    return dialogService.httpError({ status: 401, error: err });
  }
}
